import React, { memo, forwardRef } from "react";
const SvgNotasubset = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M9.768 24.876a1 1 0 101.732 1l1.136-1.968a7.97 7.97 0 003.364.74h7a1 1 0 100-2h-7a5.981 5.981 0 01-2.358-.482l6.65-11.519H23a1 1 0 100-2h-1.553L22.5 6.824a1 1 0 00-1.732-1l-1.63 2.823H16a8 8 0 00-5.06 14.198l-1.172 2.031zm2.19-3.794l6.025-10.435H16a6 6 0 00-4.041 10.435z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgNotasubset.displayName = "SvgNotasubset";
const MemoForwardRef = memo(SvgNotasubset);
export default MemoForwardRef;
